<template>
  <section class="observations-section">
    <div id="observationsContainer" class="container">
      <div v-for="observation in filteredDxCards" :key="observation.id" class="card">
        <h3 style="display: flex;align-items: center;justify-content: space-between;">
          <span>{{ observation.observation }}</span>

          <div>
            <md-button style="height: 32px;width: 32px;" :class="[{'md-icon-button': true}, {'md-primary': editingId === observation.id}]" @click="toggleEdit(observation.id)">
              <md-icon>{{ editingId === observation.id ? 'save' : 'edit'}}</md-icon>
              <md-tooltip md-direction="bottom">{{editingId === observation.id ? 'Save' : 'Edit'}} card</md-tooltip>
            </md-button>
            <md-button v-if="editingId === observation.id" style="height: 32px;width: 32px;margin-left: 0.5rem" class="md-icon-button" @click="cancelEdit()">
              <md-icon>cancel</md-icon>
              <md-tooltip md-direction="bottom">Cancel edit</md-tooltip>
            </md-button>
            <md-button v-if="editingId !== observation.id" style="height: 32px;width: 32px;margin-left: 0.5rem" class="md-icon-button md-danger" @click="handleDelete(observation)">
              <md-icon>delete</md-icon>
              <md-tooltip md-direction="bottom">Remove card</md-tooltip>
            </md-button>
          </div>
        </h3>
        <p><strong>Modality:</strong> {{ observation.modality }}</p>

        <!-- Read Mode -->
        <div v-if="editingId !== observation.id">
          <p style="margin-top: 7px;"><strong>Diagnoses:</strong></p>
          <!-- <li v-for="diagnosis in observation.diagnoses" :key="diagnosis">
            {{ diagnosis }}
          </li> -->
          <li v-for="diagnosis in observation.diagnoses" :key="diagnosis">
            {{ diagnosis.split("(")[0] }}
            <a
              v-if="getICDCode(diagnosis)"
              :href="`https://www.icd10data.com/search?s=${getICDCode(diagnosis)}`"
              target="_blank"
            >
              ({{ getICDCode(diagnosis) }})
            </a>
            <span v-else-if="diagnosis.includes('(')">
              {{ diagnosis.split("(")[1] }}
            </span>
          </li>

          <p style="margin-top: 7px;"><strong>Recommendations:</strong></p>
          <li v-for="(recommendation, index) in observation.recommendations"
              :key="`rec-${index}-${recommendation}`">
            {{ recommendation }}
          </li>
        </div>
        <!-- Edit Mode -->
        <div v-else>
          <p style="margin-top: 7px;"><strong>Diagnoses:</strong></p>
          <div v-for="(diagnosis, index) in observation.diagnoses" :key="`${observation.id}-diagnosis-${index}`">
            <input v-model="observation.diagnoses[index]" type="text" class="edit-input" />
          </div>

          <p style="margin-top: 7px;"><strong>Recommendations:</strong></p>
          <div
            v-for="(recommendation, index) in observation.recommendations"
            :key="`${observation.id}-recommendation-${index}`"
          >
            <input v-model="observation.recommendations[index]" type="text" class="edit-input" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    mDxCards: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      editingId: null,
      editedCard: {},
      cloneCards: {}
    }
  },
  computed: {
    filteredDxCards() {
      return this.mDxCards
    }
  },
  methods: {
    showDetails(id) {
      alert(`Showing details for ${id}`)
    },
    getICDCode(diagnosis) {
      const match = diagnosis.match(/\(([^)]+)\)/);
      return match ? match[1] : null;
    },
    getModality(modality) {
      if (modality.toLowerCase() === "medhist") {
        return "Medical History"
      } else {
        return modality
      }
    },

    getICDLINK(diagnosis) {
      "https://www.icd10data.com/search?s=Z85.9"
    },

    cancelEdit() {
      const index = this.filteredDxCards.findIndex(card => card.id === this.editingId);
      this.filteredDxCards[index] = JSON.parse(JSON.stringify(this.cloneCards[this.editingId]));
      this.editingId = null;
    },

    toggleEdit(id) {
      if (this.editingId === id) {
        this.editedCard = this.filteredDxCards.find(card => card.id === id)
        this.$emit("save-changes", this.editedCard)
        this.editingId = null
      } else {
        this.editingId = id
        this.cloneCards[id] = JSON.parse(JSON.stringify(this.filteredDxCards.find(card => card.id === id)))
      }
    },
    handleDelete(obs) {
      this.$emit('delete', obs.id)
    }
  }
}
</script>

<style lang="css" scoped>
/* Observation Cards Section */
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.observations-section {
    margin-top: 20px;
  }

  #observationsContainer {
    margin-left: -30px;
    margin-right: -30px;
  }

  .card {
    background-color: white;
    padding: 24px;
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: left;
  }

  .card h3 {
    color: #333;
    margin: 0 0 10px 0px;
  }

  .card p {
    color: #666;
  }

  .card ul {
    list-style-type: none;
    margin-top: 10px;
    padding-left: 0;
    color: #555;
  }

  .card li {
    margin-left: 15px;
  }

  .details-btn, .edit-btn, .delete-btn {
    padding: 6px 10px;
    margin-right: 6px;
    background-color: #007BFF;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  .disabled {
    background-color: #42668b;
  }

  .details-btn:hover, .edit-btn:hover, .delete-btn:hover {
    background-color: #0056b3;
  }

.edit-input {
  width: 100%;
  padding: 8px;
  margin: 4px 0;
  border: 1px dotted #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: #dbf7ff;  /* Light gray background */
}

.edit-input:focus {
  background-color: #ffffff;  /* White background when focused */
  border-color: #007BFF;
  outline: none;
  box-shadow: 0 0 3px rgba(0,123,255,0.3);
}
</style>
